import { __decorate, __metadata } from "tslib";
import { Serialize } from '@ftr/serialization';
import { BadPaginationParamatersError } from './error/BadPaginationParamatersError';
/**
 * Facilitates query parameters as a simple pagination mechanism. Enforces that these
 * fields be populated in consumers
 *
 * @see http://jsonapi.org/format/#fetching-pagination
 */
export class PageDetails {
    /**
     * @param num of the page to retrieve
     * @param size of items to retrieve per page
     */
    constructor(num, size) {
        this.number = num;
        this.size = size;
    }
    /**
     * Paginate an array of items based on the given PageDetails.
     */
    static paginateItems(items, page) {
        if (page.number < 1) {
            throw new BadPaginationParamatersError('Page number must be 1 or greater');
        }
        if (page.size < 1) {
            throw new BadPaginationParamatersError('Page size must be 1 or greater');
        }
        const firstIdx = (page.number - 1) * page.size;
        const lastIdx = firstIdx + page.size;
        return items.slice(firstIdx, lastIdx);
    }
}
__decorate([
    Serialize(),
    __metadata("design:type", Number)
], PageDetails.prototype, "number", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", Number)
], PageDetails.prototype, "size", void 0);
